export const vehicleUseages = [
  'Pleasure',
  'Commute'
]
